'use strict';

import store from 'store';
import { addRecentlyEditedPlan } from '@pro/utils/Recent';

/**
 * Local storage management for meal plan modifications
 * Handles auto-save functionality with 42-day expiration
 */

/**
 * Save modified plan to local storage
 * @param {Object} plan - Plan to save
 * @param {Object} patient - Optional patient object for recent plan tracking
 */
export const updateEditedCopy = (plan, patient = null) => {
    if (!plan || !plan.uuid) {
        console.warn('Cannot save plan to local storage: missing plan or UUID');
        return;
    }

    // Save with 42-day expiration (same as old editor)
    const expirationTime = new Date().getTime() + 1000 * 60 * 60 * 24 * 42; // 42 days
    store.set('menu-edited-' + plan.uuid, plan, expirationTime);

    // Update recently edited plans if patient context provided
    if (patient) {
        addRecentlyEditedPlan(plan, patient);
    }
};

/**
 * Remove plan from local storage
 * @param {string} uuid - Plan UUID
 */
export const clearEditedCopy = (uuid) => {
    if (!uuid) return;
    
    store.remove('menu-edited-' + uuid);
};

/**
 * Get edited plan from local storage
 * @param {string} uuid - Plan UUID
 * @returns {Object|null} Edited plan or null if not found
 */
export const getEditedCopy = (uuid) => {
    if (!uuid) return null;
    
    return store.get('menu-edited-' + uuid);
};

/**
 * Check if plan has edited copy in local storage
 * @param {string} uuid - Plan UUID
 * @returns {boolean} True if edited copy exists
 */
export const hasEditedCopy = (uuid) => {
    if (!uuid) return false;
    
    return !!store.get('menu-edited-' + uuid);
};